import domReady from '@wordpress/dom-ready';

const MAX_INPUTS = 5;

function initInputFile(inputFileEl) {
  const input = inputFileEl.querySelector('input[type="file"]');
  const textEl = inputFileEl.querySelector('label .text');

  if (!input || !textEl) return;

  const defaultText = textEl.textContent;

  input.addEventListener('change', () => {
    textEl.textContent = input.files.length ? input.files[0].name : defaultText;
  });
}

function initMultipleFileUpload(container) {
  const placeholder = container.querySelector('.input-placeholder .input-wrapper');
  const contentWrap = container.querySelector('.mfu-wrapper');
  const moreWrap = container.querySelector('.mfu-more');
  const moreCta = moreWrap && moreWrap.querySelector('.more-file');

  if (!placeholder || !contentWrap || !moreCta) return;

  let current = contentWrap.querySelectorAll('.input-wrapper').length;

  function addInput(event) {
    event.preventDefault();

    if (current >= MAX_INPUTS) return;

    current += 1;

    const clone = placeholder.cloneNode(true);
    const cloneInput = clone.querySelector('input');
    const id = cloneInput.id + current;

    cloneInput.id = id;
    clone.querySelectorAll('label').forEach((label) => label.setAttribute('for', id));

    contentWrap.appendChild(clone);
    initInputFile(clone.querySelector('.input-file'));

    clone.classList.add('is-entering', 'is-active');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        clone.classList.remove('is-entering');
      });
    });

    if (current >= MAX_INPUTS) {
      moreWrap.classList.add('is-hidden');
    }
  }

  moreCta.addEventListener('click', addInput);
}

domReady(() => {
  document.querySelectorAll('[data-component="multipleFile"]').forEach(initMultipleFileUpload);
  document.querySelectorAll('[data-component="inputFile"]').forEach(initInputFile);
});
